import React from 'react';
import Button, { type ButtonProps } from './Button';
import CircularProgress from '../primitives/CircularProgress';

const BUSY_SPINNER_SIZE = 16;

export interface BusySubmitButtonProps
  extends Omit<ButtonProps, 'children' | 'startIcon' | 'disabled' | 'onClick'> {
  busy?: boolean;
  label: React.ReactNode;
  busyLabel: React.ReactNode;
  disabled?: boolean;
  onClick?: () => void;
}

/** Submit/action button with busy spinner + progressive label (busy-buttons.mdc). */
const BusySubmitButton: React.FC<BusySubmitButtonProps> = ({
  busy = false,
  label,
  busyLabel,
  disabled = false,
  onClick,
  intent = 'primary',
  ...buttonProps
}) => (
  <Button
    intent={intent}
    onClick={onClick}
    disabled={disabled || busy}
    startIcon={
      busy ? <CircularProgress size={BUSY_SPINNER_SIZE} color="inherit" /> : undefined
    }
    {...buttonProps}
  >
    {busy ? busyLabel : label}
  </Button>
);

export default BusySubmitButton;
